<template>
  <div class="about">
    <DashHeader />
    <div class="page">
      <h1>About Daily-Snapshot</h1>
      <p>About this point in every recent election cycle I find myself checking about a dozen key election indicators every day with my morning coffee. This year, as my personal COVID-19 shelter in place project, I decided to make this dashboard to put all that ever-changing data in one place.</p>

      <p>This site shows data from the most recent polling from high quality (538 "B-"rated or better) pollsters and the current betting odds from FTX and BetFair. I update daily based on whatever new high quality polls have come out in the past 24 (ish) hours. This means the data shown here is more current – but also more volatile – that polling averages at places like Real Clear Politics and FiveThirtyEight.</p>
      <p>I'm doing this on my own, with a lot of technical help from my more technically savvy brother. There will be typos. Still, I hope you find it helpful.</p>
      <p class="signature">-- Stephen Voltz</p>

      <hr />

      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSfP4bFX6GrwSSujMwXJUvoC289YEKGHKTpS74QBME5GB8GBdw/viewform?embedded=true"
        width="540"
        height="560"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
      >Loading…</iframe>

      <p>
        <router-link class="page_nav_button" to="/">Back Dashboard</router-link>
      </p>
    </div>
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
export default {
  name: "About",
  components: {
    DashHeader
  }
};
</script>
<style scoped >
.signature {
  text-align: right;
}
</style>